import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

const META: Meta = {
  description: 'User submitted thumbs up or thumbs down feedback on a workspace agent assistant message',
  name: 'agent_message_feedback_submitted',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The id of the assistant message that received feedback',
      name: 'message_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The id of the workspace agent session the message belongs to',
      name: 'session_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The sentiment of the feedback',
      name: 'sentiment',
      required: true,
      type: 'enum',
      values: ['thumbs_up', 'thumbs_down'],
    },
  ],
};

export default META;
